import type { SlotContents as PLPSlotContents } from '@amplience/content-types/typings/s-plp-layout';
import type { Maybe } from '@storefront/lib-global';
import { ScrollToTop, useLocaleContext, useMasterLayoutContext } from '@storefront/lib-global';
import type { HandlebarTemplateProps } from '@storefront/lib-global/globalComponents/handlebarTemplate';
import { renderAmplienceSlotComponents } from '@storefront/lib-global/utils/amplienceUtils';
import { PLPAmplienceComponents } from '../plpAmplienceComponents';
import { CategoryDescription, DescriptionContainer, HorizontalLine } from './SlotAndDescription.styles';

export type SlotAndDescriptionProps = {
  slotContent?: PLPSlotContents | null;
  handlebarComponents?: HandlebarTemplateProps[] | null;
  categoryDescription: Maybe<string> | undefined;
  isDesktop?: boolean;
  isPLP?: boolean;
  locale?: string | undefined;
};

const AmplienceComponents = {
  ...PLPAmplienceComponents,
};

export function SlotAndDescription({
  slotContent,
  handlebarComponents,
  categoryDescription,
  isDesktop,
  isPLP,
}: SlotAndDescriptionProps) {
  const { locale } = useLocaleContext();
  const { masterLayoutData } = useMasterLayoutContext();
  const { footerComponent } = { ...masterLayoutData };
  const scrollToTop = footerComponent?.scrollToTop;

  return (
    <>
      {!!slotContent &&
        renderAmplienceSlotComponents(slotContent?.pageContent, AmplienceComponents, handlebarComponents, locale)}
      {scrollToTop && <ScrollToTop isDesktop={isDesktop} {...scrollToTop} />}
      {(isPLP || isDesktop) && <HorizontalLine $isDesktop={isDesktop} />}
      {categoryDescription && (
        <DescriptionContainer $isDesktop={isDesktop}>
          <CategoryDescription data-testid="categoryDescription" aria-label={categoryDescription} $isPLP={isPLP}>
            {categoryDescription}
          </CategoryDescription>
        </DescriptionContainer>
      )}
    </>
  );
}
